var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control-device"},[_c('base-button',{staticClass:"control-device__btn",on:{"click":_vm.clearCache}},[_vm._v("Clear cache")]),_c('base-button',{staticClass:"control-device__btn",on:{"click":_vm.restart}},[_vm._v("Restart")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }